export const websiteTools = [
    {
        'name': '预约系统',
        'url': 'https://reservation.b-tronsemi.com/',
        'favicon': 'https://reservation.b-tronsemi.com/favicon.ico'
    },
    {
        'name': '技术论坛',
        'url': 'http://127.0.0.1:8080/articleShowList',
        'favicon': 'https://emc.b-tronsemi.com/favicon.ico'
    },
    {
        'name': '百度',
        'url': 'https://www.baidu.com/',
        'favicon': 'https://www.baidu.com/favicon.ico'
    },
    {
        'name': '百度翻译',
        'url': 'https://fanyi.baidu.com/mtpe-individual/transText#/',
        'favicon': 'https://fanyi.baidu.com/favicon.ico'
    },
    {
        'name': '飞书',
        'url': "https://www.feishu.cn/",
        'favicon': "https://www.feishu.cn/favicon.ico"
    },
    {
        'name': '阿里云',
        'url': 'https://www.aliyun.com/?spm=5176.30371578.J_4VYgf18xNlTAyFFbOuOQe.d_logo.6555154a6Nj7j5',
        'favicon': 'https://gw.alicdn.com/imgextra/i2/O1CN01XiIVip1bYyTsuq6Wy_!!6000000003478-2-tps-180-180.png'
    },
    {
        'name': 'deepseek',
        'url': 'https://www.deepseek.com/',
        'favicon': 'https://www.deepseek.com/favicon.ico'
    },
    {
        'name': '豆包',
        'url': 'https://www.doubao.com/chat/?channel=itab2&source=hw_db_itab&type=tab&theme=wangzjh',
        'favicon': 'https://lf-flow-web-cdn.doubao.com/obj/flow-doubao/doubao/chat/favicon.png'
    },
    {
        'name': 'AI工具集',
        'url': 'https://ai-bot.cn/?utm_source=itab',
        'favicon': 'https://ai-bot.cn/favicon.ico'
    },
    {
        'name': '矢量图标库',
        'url': 'https://www.iconfont.cn/',
        'favicon': 'https://www.iconfont.cn/favicon.ico'
    },
    {
        'name': '哔哩哔哩',
        'url': 'https://www.bilibili.com/',
        'favicon': 'https://www.bilibili.com/favicon.ico'
    },
    {
        'name': '樱之空',
        'url': 'https://skr.skr3.cc:666/',
        'favicon': 'https://skr.skr3.cc:666/favicon.ico'
    },
    {
        'name': 'logo设计',
        'url': 'https://www.uugai.com/',
        'favicon': 'https://www.uugai.com/favicon.ico'
    },
    {
        'name': '程序员工具箱',
        'url': "https://it.xygalaxy.com/",
        'favicon': "https://it.xygalaxy.com/favicon.ico"
    },
    {
        'name': '在线工具',
        'url': "https://tool.lu/",
        'favicon': "https://tool.lu/favicon.ico"
    },
    {
        'name': '快捷键速查',
        'url': "https://www.xygalaxy.com/quickKeys",
        'favicon': "https://www.xygalaxy.com/favicon.ico"
    },
    {
        'name': '在线白板',
        'url': "https://tool.mkblog.cn/whiteboard/",
        'favicon': "https://tool.mkblog.cn/favicon.ico"
    },
    {
        'name': '网络面板',
        'url': "https://net.netart.cn/",
        'favicon': "https://net.netart.cn/icon.png"
    }
]


// WEBPACK FOOTER //
// ./src/views/classify/websiteTools.js